export function photoSharePath(pathname, albumId, photoId) {
  const params = new URLSearchParams({ album: String(albumId), photo: String(photoId) });
  return `${pathname}?${params}`;
}

export function sharedPhotoIndex(photos, photoId) {
  return photoId ? photos.findIndex((photo) => String(photo.id) === photoId) : -1;
}
